/**
 * 受付（/reception）の発話終了時に再生する「お辞儀」モーションの定義。
 *
 * ★方式★
 * emitter の "expression" イベントに「再生したいモーションのファイル名」を直接載せる。
 * 受付の呼び出し側が `endExpression: receptionBowEndExpression()` を渡すと、
 * 発話終了時に `"motion:Quick Formal Bow.fbx"` が emit され、
 * Model 側（handleExpression）が接頭辞 `motion:` を検知して**完全一致**で再生する。
 *
 * ★完全一致である点に注意★
 * - サーバ `getAnimationFiles()` が返す `name`（= 拡張子付きの完全なファイル名）と
 *   **完全一致**するファイルだけが再生対象になる。部分一致（includes）でもランダム選択でもない。
 * - 拡張子（.fbx）まで含めて正確に記述すること。
 *
 * ★固定 1 ファイル★
 * 受付のお辞儀は下記 1 ファイルに固定する。差し替える場合はこの定数だけを編集すれば、
 * 呼び出し側・Model 側は変更不要。
 */

/**
 * 受付お辞儀モーションのファイル名（拡張子含む・完全一致）。
 * server/public/motions に実在するファイルと完全一致していること。
 */
export const RECEPTION_BOW_MOTION = "Quick Formal Bow.fbx";

/**
 * emitter の "expression" イベントで「ファイル名指定の完全一致モーション再生」を表す接頭辞。
 *
 * これが単一定義源（single source of truth）。Model 側の handleExpression も
 * この定数を import して接頭辞判定に使うこと（マジック文字列の二重管理を避けるため）。
 */
export const MOTION_EXPRESSION_PREFIX = "motion:";

/**
 * 受付の発話終了時に渡す `endExpression` 値を組み立てて返す。
 *
 * - 返り値: `"motion:Quick Formal Bow.fbx"`（接頭辞 + 完全一致ファイル名）。
 * - 受付の呼び出し側（CompleteReceptionPage / ReceptionStandbyScreen）が
 *   `usePlayVoiceWithCooldown({ endExpression: receptionBowEndExpression() })` のように使う。
 * - chat 側はこれを使わないため、新しい "motion:" 分岐は chat では発火しない（非影響）。
 */
export const receptionBowEndExpression = (): string =>
  `${MOTION_EXPRESSION_PREFIX}${RECEPTION_BOW_MOTION}`;
